import { handleActions } from 'redux-actions';
import {
  addBreadcrumb,
  removeBreadcrumb,
  addCookies,
  rememberEditCookies,
} from '../actions/layoutActions';

const defaultState = {
  breadcrumbs: [
    {
      active: false,
      label: 'general_home',
      link: '/home',
      isModify: false,
    },
  ],
  cookies: null,
  rememberEdit: null,
};

export default handleActions(
  {
    [addBreadcrumb](state, action) {
      const filterPath = state.breadcrumbs.filter((x) => x.link !== action.payload.link);
      let newFilterPath = [];

      filterPath.forEach((element) => {
        newFilterPath = [...newFilterPath, { ...element, active: false }];
      });
      const newBreadcrumbs = [...newFilterPath, action.payload];
      return { ...state, breadcrumbs: newBreadcrumbs };
    },
    [removeBreadcrumb](state) {
      state.breadcrumbs.pop();
      state.breadcrumbs.pop();
      return { ...state, breadcrumbs: state.breadcrumbs };
    },
    [addCookies](state, action) {
      return { ...state, cookies: action.payload };
    },
    [rememberEditCookies](state, action) {
      return { ...state, rememberEdit: action.payload };
    },
  },
  defaultState
);
